<mat-card>
  <mat-card-header>
    <mat-card-title style="margin-bottom: 16px"
      >Erreurs la syncro</mat-card-title
    >
  </mat-card-header>

  <mat-card-content>
    <app-generic-table
      [config]="tableConfig"
      [rows]="listSyncroLogs"
      [pageInformations]="pageInformations"
      (pageEmit)="pageEvent($event)"
      [isClickable]="false"
    ></app-generic-table>
  </mat-card-content>
</mat-card>

